<h1 class="accessibility-only">{{ 'challenges.page.title' | translate : { fgbdefault: 'Challenges' } }}</h1>

<div class="home-page-container">
  <!-- How it works -->
  <div class="container">
    <button class="btn how-it-work" (click)="open()">
      <a>{{ 'how.it.work' | translate }}</a>
    </button>
  </div>

  <!-- Voucher widget -->
  <div class="container">
    <fgb-vouchers></fgb-vouchers>
  </div>

  <!-- Badges earned -->
  <div class="container">
    <fgbcl-badge-achieved />
  </div>

  <!-- Scorecard list -->
  <fgbcl-scorecard-list-view
    [icon]="'chevron_right'"
    [confettiColors]="['#8921fe', '#7ec6fe']"
    [isSponsorInBody]="false"
    [showPlaceholder]="true"
  ></fgbcl-scorecard-list-view>
</div>
